import { useCallback, useEffect, useState } from 'react';
import { noop } from 'lodash-es';

export function useOutsideAlerter(ref, params) {
  const [isAbandonShow, setIsAbandonShow] = useState(false);
  const [url, setUrl] = useState('');

  const { isAbandonFlow } = params;
  const handleClickOutside = useCallback(
    event => {
      if (ref.current && !ref.current.contains(event.target)) {
        const anchor = event.target.closest('a');

        if (anchor) {
          anchor.addEventListener('click', e => e.preventDefault());
          setIsAbandonShow(true);
          setUrl(anchor.href);
        }
      }
    },
    [ref]
  );

  useEffect(() => {
    if (isAbandonFlow) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
    return noop;
  }, [handleClickOutside, isAbandonFlow, ref, setUrl, setIsAbandonShow]);
  return [isAbandonShow, url, setIsAbandonShow];
}
